import {
  NameColumnDef,
  EmailColumnDef,
  CityColumnDef,
  CountryColumnDef,
  StateColumnDef,
  ZipcodeColumnDef,
  PhoneColumnDef,
  FaxColumnDef,
  ContactColumnDef,
  VendorColumnDef,
} from "components/AGTable/NewColumns/ColumnDefinition";

const defaultColDef = {
  sortable: true,
  resizable: true,
  cellClass: "no-border",
  filter: true,
  cellStyle: { display: "flex", "justify-content": "center" },
};

export const CarrierWarehouseGrid = {
  columnDefs: [
    VendorColumnDef("vendor"),
    NameColumnDef,
    CityColumnDef,
    StateColumnDef,
    CountryColumnDef,
    ZipcodeColumnDef("zip"),
    PhoneColumnDef,
    EmailColumnDef,
    FaxColumnDef,
    ContactColumnDef,
  ],
  defaultColDef,
};
